import { TypeDefinition } from "../generic";

export class DisplayUITypes {
    public static Grader: TypeDefinition = { id: 1, name: "Grader UI" };
    public static MeetingSite: TypeDefinition = { id: 2, name: "Meeting site" };

    public static Values: TypeDefinition[] = [
        DisplayUITypes.Grader,
        DisplayUITypes.MeetingSite,
    ];

    public static IDs: number[] = DisplayUITypes.Values.map((v) => v.id);

    public static isPrimary = (r: number | { roleId: number }) => {
        const x = typeof r === "number" ? r : (r ? r.roleId : 0);
        return x === DisplayUITypes.Grader.id;
    }
}



// WEBPACK FOOTER //
// ./src/models/abstract/DisplayUITypes.ts